
export default function Pagination({ currPage, setCurrPage, totalPages }) {
    return (
        <div className="pagination">
            <div
                onClick={() => setCurrPage(currPage - 1)}
                disabled={currPage === 1}
                className="arrow prev"
            >
            </div>
            <div className="page-numbers">
                {Array.from({ length: totalPages }, (_, index) => (
                    <span 
                        key={index + 1}
                        onClick={() => setCurrPage(index + 1)}
                        className={currPage === index + 1 ? 'active' : ''}
                    >
                        {index + 1}
                    </span>
                ))}
            </div>
            <div
                onClick={() => setCurrPage(currPage + 1)}
                disabled={currPage === totalPages} 
                className="arrow next"
                >

            </div>
        </div>
    );
}